const sizeMap = {
    sm: 'sm',
    md: 'md',
    xg: 'xg',
    lg: 'lg',
    nm: 'nm', // Input、InputNumber
    xlg: 'xlg', // Modal
    small: 'sm',
    middle: 'md',
    large: 'lg',
    default: 'default', // Badge、Card
}
function setComponentSize(val?: string | number) {
    if (typeof val === 'number') {
        return val
    } else {
        if (val) {
            return sizeMap[val]
        }
        return
    }
}
export default setComponentSize